module.exports = __webpack_public_path__ + "media/images/new_landing/logos/reebok-78527b9532dc7dabbadc98003673230c.png";